import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useTheme } from '../../hooks/useTheme';
import AdminPanel from '../admin/AdminPanel';
import Swal from 'sweetalert2';

const Navbar: React.FC = () => {
  const { user, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();
  const [showAdminPanel, setShowAdminPanel] = useState(false);

  const handleLogout = async () => {
    const result = await Swal.fire({
      title: 'Logout Confirmation',
      text: 'Are you sure you want to logout?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#ff6b35',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Yes, logout'
    });

    if (result.isConfirmed) {
      logout();
      navigate('/login');
      Swal.fire({
        title: 'Logged Out',
        text: 'You have been successfully logged out.',
        icon: 'success',
        timer: 1500,
        showConfirmButton: false
      });
    }
  };

  const showAdminPanelModal = () => {
    setShowAdminPanel(true);
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg bg-body-tertiary shadow-sm">
        <div className="container-fluid">
          {/* Brand */}
          <a className="navbar-brand fw-bold text-orange" href="#">
            <i className="bi bi-boxes me-2"></i>
            Tay Supplies Management
          </a>

          {/* Mobile toggle */}
          <button 
            className="navbar-toggler" 
            type="button" 
            data-bs-toggle="collapse" 
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Navbar content */}
          <div className="collapse navbar-collapse" id="navbarNav">
            <div className="navbar-nav ms-auto align-items-center">
              {/* Theme switcher */}
              <button 
                className="theme-switcher me-3"
                onClick={toggleTheme}
                title={`Switch to ${theme === 'light' ? 'dark' : 'light'} theme`}
              >
                <i className={`bi bi-${theme === 'light' ? 'moon' : 'sun'}-fill`}></i>
              </button>

              {/* User info */}
              <div className="nav-item dropdown">
                <a 
                  className="nav-link dropdown-toggle d-flex align-items-center" 
                  href="#" 
                  role="button" 
                  data-bs-toggle="dropdown"
                >
                  <i className="bi bi-person-circle me-2"></i>
                  {user?.username}
                  <span className="badge bg-orange ms-2 small">{user?.department}</span>
                </a>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li>
                    <span className="dropdown-item-text">
                      <small className="text-muted">Role: {user?.role}</small>
                    </span>
                  </li>
                  <li><hr className="dropdown-divider" /></li>
                  
                  {/* Admin panel for admin users */}
                  {user?.isAdmin && (
                    <>
                      <li>
                        <button className="dropdown-item" onClick={showAdminPanelModal}>
                          <i className="bi bi-gear me-2"></i>
                          Admin Panel
                        </button>
                      </li>
                      <li><hr className="dropdown-divider" /></li>
                    </>
                  )}
                  
                  <li>
                    <button className="dropdown-item" onClick={handleLogout}>
                      <i className="bi bi-box-arrow-right me-2"></i>
                      Logout
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Admin Panel Modal */}
      <AdminPanel 
        show={showAdminPanel} 
        onClose={() => setShowAdminPanel(false)} 
      />
    </>
  );
};

export default Navbar;
